<template>
	<div class="card" :style="cssVariables">
		<div class="grid grid-cols-1">
			<div class="col-span-1 card-header-wrapper">
				<slot name="header"></slot>
			</div>
			<div class="col-span-1 card-content-wrapper">
				<slot name="content"></slot>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'simple-card',
	props: {
		cardBorderColor: {
			type: String,
			default: null
		},
		cardHeaderBgColor: {
			type: String,
			default: '#fff'
		},
		cardHeaderTextColor: {
			type: String,
			default: '#292637'
		},
		cardContentBgColor: {
			type: String,
			default: '#ccc'
		},
		cardContentTextColor: {
			type: String,
			default: '#292637'
		},
		textAlign: {
			type: String,
			default: 'left'
		}
	},
	computed: {
		cssVariables() {
			return {
				'--card-border-color': this.cardBorderColor,
				'--header-bg-color': this.cardHeaderBgColor,
				'--header-text-color': this.cardHeaderTextColor,
				'--content-bg-color': this.cardContentBgColor,
				'--content-text-color': this.cardContentTextColor,
				'--text-align': this.textAlign
			}
		}
	}
}
</script>
<style lang="postcss" scoped>
	.card {
		display: flex;
		flex-direction: column;
		text-align: var(--text-align);
		border: 2px solid var(--card-border-color);
		.card-header-wrapper {
			padding: 1rem;
			background-color: var(--header-bg-color);
			color: var(--header-text-color);
		}
		.card-content-wrapper {
			padding: 1rem;
			background-color: var(--content-bg-color);
			color: var(--content-text-color);
		}
	}
</style>